import castArray from 'lodash/castArray';
import { observable, makeObservable, override } from 'mobx';

import { AbstractField } from './AbstractField';
import { store } from '@store';
import { assertIsDefined } from '@utils/assertIsDefined';

export class CheckboxListField extends AbstractField<string[], string[]> {
    @observable
    private options_?: Map<string, string>;

    constructor(params: string[], name: string) {
        super(params, name);
        makeObservable(this);
    }

    @override
    public get hasData(): boolean {
        return this.fieldValue.length > 0;
    }

    public makeUpdateParams() {
        return this.fieldValue;
    }

    public getPreview(): string {
        if (!this.options_) {
            this.setData();
        }
        const options = this.options_;
        assertIsDefined(options, 'Field options are built by setData above');

        return castArray(this.fieldValue)
            .map(value => options.get(value) || value)
            .join(', ');
    }

    public isEqual(value: string[]): boolean {
        return `${value}` === `${this.fieldValue}`;
    }

    public setData() {
        const {
            common: { fieldsParams },
        } = store;
        const fieldParams = fieldsParams.get(this.fieldName);
        assertIsDefined(fieldParams, `Field params of ${this.fieldName} are loaded with the entry type`);
        const { data } = fieldParams;

        const options = new Map<string, string>();

        data?.options?.forEach(option => {
            options.set(option.value, option.label);
        });

        this.options_ = options;
    }

    protected setDefaultValueValue() {
        this.defaultNullValue = [];
    }

    protected setFieldValue(value: string[]) {
        this.fieldValue = value;
    }
}
